<template lang="pug">
  el-scrollbar.h-100
    Header
    el-main.pa-0.min-w12.ma-auto(:style="'background-color:#f9fcfe;min-height:'+h")
      //div(style="height:60px")
      div.text-center(style="line-height:60px;color:#ff7429") 账号已注册登录，请继续完成认证！
      div.ma-auto.px-5(style="width:1000px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);border-radius:10px;border-top:4px solid #ff7429;")
        div.text-center.title(style="line-height:60px;color:#ff7429") 供应商认证
        el-alert.mb-5(v-if="formAuth.checkstatus==5" :title="'驳回原因:'+formAuth.remark+'。操作时间:'+formAuth.update_time" type="error" :closable="false")
        el-row.py-0.mb-5(type="flex" justify="center")
          el-col(:span="6")
            el-radio-group(v-model="formAuth.type" @change="changeType")
              el-radio(:label="1") 企业认证
              el-radio(:label="2") 个人认证
        el-row.py-0.mb-9(type="flex" justify="center")
          el-col(:span="14")
            el-form(:model="formAuth" ref="formAuth" label-width="140px" :rules="rules")
              el-form-item(label="管理组织" prop="pk_org")
                el-select.w-100(v-model="formAuth.pk_org" filterable placeholder="管理组织" clearable)
                  el-option(v-for="item in purchase_org" :key="item.pk_org" :label="item.name" :value="item.pk_org")
              el-form-item(v-if="formAuth.type==1" label="企业名称" prop="name")
                el-row.w-100(type="flex" :gutter="10")
                  el-col(:span="17")
                    el-input(v-model="formAuth.name" placeholder="企业名称")
                  el-col(:span="5")
                    el-button(type="primary" @click="getQXB" slot="reference") 查询企信宝
                    //- el-popover(placement="top-start" width="200" trigger="hover" content="该操作只提供一次查询，请谨慎使用。")
                    //-   el-button(type="primary" @click="getQXB" slot="reference") 查询企信宝
              el-form-item(v-else label="个体名称" prop="name")
                el-input(v-model="formAuth.name" placeholder="个体名称")
              el-form-item(v-if="formAuth.type==1" label="公司地址" prop="address")
                el-input(v-model="formAuth.address" placeholder="公司地址")
              el-form-item(v-else label="地址" prop="address")
                el-input(v-model="formAuth.address" placeholder="地址")
              el-form-item(v-if="formAuth.type==1" label="注册资金" prop="registered_funds")
                el-input(v-model="formAuth.registered_funds" placeholder="注册资金")
              el-form-item(v-if="formAuth.type==1" label="法人姓名" prop="registrant")
                el-input(v-model="formAuth.registrant" placeholder="法人姓名")
              el-form-item(v-if="formAuth.type==1" label="法人电话" prop="registrant_phone")
                el-input(v-model="formAuth.registrant_phone" placeholder="法人电话")
              el-form-item(v-if="formAuth.type==1" label="经营范围" prop="scope")
                el-input(v-model="formAuth.scope" placeholder="经营范围")
              el-form-item(v-if="formAuth.type==1" label="纳税等级" prop="tax_class")
                el-select.w-100(v-model="formAuth.tax_class" placeholder="纳税等级")
                  el-option(label="无" value="无")
                  el-option(label="A级纳税人" value="A级纳税人")
                  el-option(label="B级纳税人" value="B级纳税人")
                  el-option(label="C级纳税人" value="C级纳税人")
                  el-option(label="D级纳税人" value="D级纳税人")
                  el-option(label="M级纳税人" value="M级纳税人")
              el-form-item(v-if="formAuth.type==1" label="纳税等级证明" prop="img_tax_class")
                el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,7) }" :before-upload="(file)=>{ return beforeUpload(file,7) }")
                  img.auth-img(v-if="formAuth.img_tax_class" :src="img_url+formAuth.img_tax_class")
                  i.el-icon-plus.auth-uploader-icon(v-else)
              el-form-item(v-if="formAuth.type==1" label="统一社会信用代码" prop="credit_code")
                el-input(v-model="formAuth.credit_code" placeholder="统一社会信用代码")
              el-form-item(v-if="formAuth.type==1" label="营业执照许可证" prop="img_business_license")
                el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,1) }" :before-upload="(file)=>{ return beforeUpload(file,1) }")
                  img.auth-img(v-if="formAuth.img_business_license" :src="img_url+formAuth.img_business_license")
                  i.el-icon-plus.auth-uploader-icon(v-else)
              el-form-item(v-if="formAuth.type==1" label="开户行许可证" prop="img_bank_license")
                el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,2) }" :before-upload="(file)=>{ return beforeUpload(file,2) }")
                  img.auth-img(v-if="formAuth.img_bank_license" :src="img_url+formAuth.img_bank_license")
                  i.el-icon-plus.auth-uploader-icon(v-else)
              el-form-item(v-if="formAuth.type==1" label="法人身份证" prop="img_registrant_id_card")
                el-row(type="flex" justify="center")
                  el-col(:span="12")
                    el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,3) }" :before-upload="(file)=>{ return beforeUpload(file,3) }")
                      img.auth-img(v-if="formAuth.img_registrant_id_card" :src="img_url+formAuth.img_registrant_id_card")
                      i.el-icon-plus.auth-uploader-icon(v-else) 法人身份证正面
                  el-col(:span="12")
                    el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,4) }" :before-upload="(file)=>{ return beforeUpload(file,4) }")
                      img.auth-img(v-if="formAuth.img_registrant_id_card_back" :src="img_url+formAuth.img_registrant_id_card_back")
                      i.el-icon-plus.auth-uploader-icon(v-else) 法人身份证反面
              el-form-item(label="注册人身份证" prop="img_agent_id_card")
                el-row(type="flex" justify="center")
                  el-col(:span="12")
                    el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,5) }" :before-upload="(file)=>{ return beforeUpload(file,5) }")
                      img.auth-img(v-if="formAuth.img_agent_id_card" :src="img_url+formAuth.img_agent_id_card")
                      i.el-icon-plus.auth-uploader-icon(v-else) 注册人身份证正面
                  el-col(:span="12")
                    el-upload.auth-uploader(:show-file-list="false" :headers="http_header" accept=".jpg,.png,.jpeg" :action="path" :on-success="(res,file)=>{ return handleSuccess(res,file,6) }" :before-upload="(file)=>{ return beforeUpload(file,6) }")
                      img.auth-img(v-if="formAuth.img_agent_id_card_back" :src="img_url+formAuth.img_agent_id_card_back")
                      i.el-icon-plus.auth-uploader-icon(v-else) 注册人身份证反面
              //- el-form-item(label="开户行名称" prop="bank_name")
              //-   el-input(v-model="formAuth.bank_name" placeholder="开户行名称")
              //- el-form-item(label="开户行行号" prop="bank_code")
              //-   el-input(v-model="formAuth.bank_code" placeholder="开户行行号")
              //- el-form-item(label="银行账号" prop="bank_account")
              //-   el-input(v-model="formAuth.bank_account" placeholder="银行账号")
              el-form-item(label="联系人" prop="contact")
                el-input(v-model="formAuth.contact" placeholder="联系人")
              el-form-item(label="联系电话" prop="contact_phone")
                el-input(v-model="formAuth.contact_phone" placeholder="联系电话")
              el-form-item(v-if="formAuth.type==2" label="身份证号" prop="id_num")
                el-input(v-model="formAuth.id_num" placeholder="身份证号")
              el-row
                el-col
                  div
                    div.fl.body-1 银行账号
                    div.fr
                      el-button(type="primary" size="mini" @click="dialogFormVisible = true") 新增
                  el-table(:header-cell-style="{'background-color':'#f9fcfe'}" :data="bankData" row-key="id" size="mini" style="background-color:#f9fcfe;")
                    el-table-column(prop="bank_code" label="开户行行号")
                    el-table-column(prop="bank_name" label="开户行名称")
                    el-table-column(prop="bank_account" label="银行账号")
                    el-table-column(prop="name_account" label="账户名")
                    el-table-column(prop="ower_account" label="账户持有人")
                    el-table-column(prop="is_private" label="是否私人账户")
                      template(slot-scope="scope")
                        span {{scope.row.is_private=='Y'?"是":"否"}}
                    el-table-column(label="操作" width="80" key="op")
                      template(slot-scope="scope")
                        el-button(type="danger" size="mini" plain @click="del(scope.$index)") 删除
              el-form-item.mt-2.text-left(prop="checked")
                el-checkbox(v-model="checked") 已阅读并同意
                el-button(type="text" @click="dialogVisible = true") 《建华建材认证协议》
              el-form-item
                el-button.w-100.button-bg.white--text(@click="submitForm('formAuth')") 提交认证
    Footer
    el-dialog.dialog(title="新增银行账号" :visible.sync="dialogFormVisible" width="380px" :show-close="false" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="form1" ref="form1" size="mini" label-width="100px" :rules="rules")
        el-form-item(label="开户行" prop="bank_code")
          el-select.w-100(v-model="bankItem" value-key="id" @change="changeBank" filterable remote placeholder="请搜索开户行" :remote-method="getBankList" :loading="loadingBank")
            el-option(v-for="item in bankList" :key="item.id" :label="item.name" :value="item")
        el-form-item(label="银行账号" prop="bank_account")
          el-input(v-model.trim="form1.bank_account" @keyup.native="form1.bank_account = $event.target.value.replace(/\\s+/g,'')")
        el-form-item(label="账户名" prop="name_account")
          el-input(v-model.trim="form1.name_account" @keyup.native="form1.name_account = $event.target.value.replace(/\\s+/g,'')")
        el-form-item(label="账户持有人" prop="ower_account")
          el-input(v-model.trim="form1.ower_account" @keyup.native="form1.ower_account = $event.target.value.replace(/\\s+/g,'')")
        el-form-item(label="是否私人账户" prop="is_private")
          el-select.w-100(v-model="form1.is_private" filterable placeholder="是否私人账户")
            el-option(label="是" value="Y")
            el-option(label="否" value="N")
        //el-form-item(label="是否私人账户")
          el-switch(v-model="form1.is_private" :active-value="Y" :inactive-value="N")
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormVisible = false") 取 消
        el-button(size="mini" type="primary" @click="addBank") 确 定
    el-dialog(:visible.sync="dialogVisible" width="80%")
      span(slot="title")
        div.title.w-100.text-center 建华建材电子采购平台注册协议
      div.mx-5
        div.mb-2.body-2 一、特别提示
        div.mb-2 1. 本《建华建材电子采购平台注册协议》（以下简称“本协议”）是您（以下简称“您”或“用户”）与建华建材电子采购平台网站(网址:http://www.jianhuabm.com:7083)的经营者建华建材（镇江）有限公司（以下简称“建华建材电子采购平台”）之间关于您注册并使用建华建材电子采购平台以获得相应服务（以下简称“建华建材电子采购平台服务”）所订立的对双方有约束力的协议。
        div.mb-2 2. 建华建材电子采购平台已经发布的或未来可能发布的各项服务对应的服务协议、使用规则、结算规则、法律声明等，均构成本协议的组成部分，与本协议具有同等法律效力。如果本协议某一（些）条款被认定为无效，而其他条款仍能保持有效且其执行不受影响，建华建材电子采购平台可决定是否继续履行该等其他条款。
        div.mb-2 3. 请您认真阅读本协议并充分理解本协议各条款的内容。如果您对本协议的条款有疑问的，请通过建华建材电子采购平台网站所载的联系方式进行咨询，建华建材电子采购平台将向您解释条款内容。一旦您按照注册页面提示填写信息、提交文件、阅读并同意本协议且完成注册后，即表示您已经充分阅读、理解并接受本协议的全部内容。如果您不同意接受本协议或其任何条款的约定或无法准确理解建华建材电子采购平台对本协议条款的解释，您应当立即终止注册程序及在建华建材电子采购平台网站上的任何操作。
        div.mb-2 4. 您理解并同意，建华建材电子采购平台有权根据法律法规的变化及经营需要，不时对本协议条款进行修改并公布在建华建材电子采购平台网站，您应在确认充分理解并同意更新后的本协议后方使用建华建材电子采购平台服务。一旦您开始使用建华建材电子采购平台服务，将被视为对本声明和政策内容的接受和认可。
        div.mb-2 5. 您确认，您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下简称“法律主体”）。如果您不具备前述法律主体资格，请立即终止注册程序及在建华建材电子采购平台网站上的任何操作，且建华建材电子采购平台有权注销您的帐号。建华建材电子采购平台因此受到损失的，将向您和/或您的监护人索赔。
        div.my-2.body-2 二、建华建材电子采购平台帐号
        div.mb-2 1. 帐号的获取
        div.mb-2 在您按照建华建材电子采购平台网站注册页面的提示信息填写完整注册信息、完成《建华建材电子采购平台服务协议》的阅读、并完成帐号激活操作等全部建华建材电子采购平台注册程序后，或者建华建材电子采购平台以其他方式向您提供建华建材电子采购平台登录帐号后，您即获得了建华建材电子采购平台帐号并正式成为建华建材电子采购平台的用户。
        div.mb-2 2. 注册信息
        div.mb-2 您应当保证您在注册过程中填写的信息准确、真实和完整。如果您填写的信息（包括但不限于联系地址、电话、电子邮件等）有任何变更，您应当及时登录建华建材电子采购平台进行更新。如果建华建材电子采购平台发现您填写的注册信息存在错误、不真实或不完整的情况，或通过您填写的联系方式信息无法联系到您，建华建材电子采购平台有权要求您立即进行改正、更新相关信息。
        div.mb-2 3. 实名认证
        div.mb-2 您理解并同意，即使您获得了建华建材电子采购平台帐号亦不代表您已开通了建华建材电子采购平台的所有服务。为保障帐号及交易安全，建华建材电子采购平台可能会随时要求您提交更多的身份资料和信息以完成帐号的实名认证，只有完成帐号的实名验证，您才可以使用相应的建华建材电子采购平台服务。您授权建华建材电子采购平台可以通过第三方查询和审核您的身份和资料。
        div.mb-2 4. 帐号安全
        div.mb-2 您应当妥善保管您的建华建材电子采购平台帐号和密码，您通过建华建材电子采购平台帐号执行的一切操作都不可撤回并将被视为是您身份及行为的唯一识别依据，您须对在该建华建材电子采购平台帐号下发生的所有活动承担责任。请您注意保护建华建材电子采购平台帐号及密码安全，并在使用完毕建华建材电子采购平台服务后安全退出登录。除非依照法律规定或者经过建华建材电子采购平台的同意，您不得以任何方式向任何地第三方泄露、转让或赠与您的建华建材电子采购平台帐号，否则建华建材电子采购平台有权随时中止或终止您的帐号使用，甚至注销您的帐号。一旦您发现任何人未经您的授权使用您的建华建材电子采购平台帐号和密码，您应当立即通知建华建材电子采购平台，建华建材电子采购平台会在合理时间内采取适当措施，但对于在建华建材电子采购平台采取措施之前发生的损失，建华建材电子采购平台不承担责任。
        div.mb-2 5. 帐号查询、冻结及注销
        div.mb-2 您理解并同意，建华建材电子采购平台根据合理判断，有权在下列情形下自行对您的帐号进行查询（包括但不限于查询注册信息、交易信息、资金信息等）、冻结和/或注销：
        div.mb-1 1） 国家司法、行政、安全机关等权力机构要求的；
        div.mb-1 2） 您通过建华建材电子采购平台帐号的操作和交易存在违反本协议约定、法律法规和/或侵犯第三人合法权益的情形的；
        div.mb-1 3） 建华建材电子采购平台基于单方面的合理判断，认为您的帐号操作、交易记录等存在异常的；
        div.mb-1 4） 您的帐号遭到其他用户投诉，且投诉用户提供一定证据予以证明的；
        div.mb-1 5） 您连续12个自然月未使用您的帐号登录建华建材电子采购平台网站，且您的帐号中不存在未到期的建华建材电子采购平台服务的；
        div.mb-1 6） 您实施了影响或侵害建华建材电子采购平台和/或建华建材电子采购平台关联公司的合法权益的行为，包括但不限于：
        div.mb-1 a. 违反建华建材电子采购平台和/或建华建材电子采购平台关联公司的服务协议、条款及规范等内容；
        div.mb-1 b. 破坏或试图破坏建华建材电子采购平台和/或建华建材电子采购平台关联公司公平交易环境或正常交易秩序；
        div.mb-1 c. 任何使用含有建华建材电子采购平台和/或建华建材电子采购平台关联公司的名称、品牌且有误导性的表述或标识，明示或暗示与建华建材电子采购平台和/或建华建材电子采购平台关联公司具有某种关系的；
        div.mb-1 d. 建华建材电子采购平台认为可能是与上述行为性质相同或存在上述类似风险的其他情形。
        div.my-2.body-2 三、建华建材电子采购平台使用规则
        div.mb-2 1.您在使用建华建材电子采购平台服务的过程中，应当遵守国家、地方法律法规、行业惯例和社会公共道德。不得利用建华建材电子采购平台进行储存、发布、传播以下信息和内容：
        div.mb-1 1） 违反国家法律法规政策的任何信息；
        div.mb-1 2） 违反国家规定的政治宣传和/或新闻信息；
        div.mb-1 3） 涉及国家秘密和/或安全的信息；
        div.mb-1 4） 封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；
        div.mb-1 5） 博彩有奖、赌博游戏；
        div.mb-1 6） 违反国家民族和宗教政策的信息
        div.mb-1 7） 妨碍互联网运行安全的信息；
        div.mb-1 8） 侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息。
        div.mb-2 此外，您不得为他人发布和传播上述不符合国家规定和/或本协议约定的信息提供任何便利，包括但不限于设置URL、BANNER链接等。
        div.mb-2 2.您保证不会利用技术或其他手段破坏或扰乱建华建材电子采购平台秩序及网络安全。
        div.mb-2 3.如果您使用的某项服务中包含可下载的建华建材电子采购平台软件，则建华建材电子采购平台仅授予您非独占性的、不可转让的、非商业性的使用许可。您不得复制、修改、发布、出售或出租服务或所含软件的任何部分，也不得进行反向工程或试图提取该软件的源代码。
        div.mb-2 4.您应当尊重建华建材电子采购平台及其他第三方的知识产权和其他合法权利，并保证在发生侵犯上述权益的违法事件时尽力保护建华建材电子采购平台及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失。
        div.mb-2 5.建华建材电子采购平台可能会以电子邮件、手机短信、电话等方式通知您服务进展情况以及提示您进行相关操作，但建华建材电子采购平台不保证您能够收到或者及时收到该邮件、手机短信或电话等。因此，在服务过程中您应当及时登录到建华建材电子采购平台查看和进行相关操作。因您没有及时查看和进行相关操作而导致纠纷或损失的，建华建材电子采购平台不承担责任。
        div.mb-2 6.您应当遵守您与建华建材电子采购平台签订的任何书面协议的约定，包括与建华建材电子采购平台签署的线下合作商务协议/服务协议、本协议及构成本协议组成部分的使用规则、结算规则、法律声明等。
        div.mb-2 7.如果您通过建华建材电子采购平台使用的某项服务来自第三方的任何产品或服务，您还可能受限于该等第三方的相关条款和条件，建华建材电子采购平台对此不予过问亦不承担任何责任，本协议不影响您与该第三方的法律关系。
        div.my-2.body-2 四、建华建材电子采购平台隐私政策
        div.mb-2 请您参见并遵守建华建材电子采购平台网站上发布并不时更新的《建华建材电子采购平台隐私权政策》。
        div.my-2.body-2 五、知识产权
        div.mb-2 除由建华建材电子采购平台的供应商、合作伙伴或入驻建华建材电子采购平台的第三方服务商提供的产品或服务外，建华建材电子采购平台上的所有内容，包括但不限于著作、图片、档案、资讯、资料、架构、页面设计，均由建华建材电子采购平台或其关联公司依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。非经建华建材电子采购平台或其关联公司书面同意，您不得以任何方式或理由对上述内容进行使用、复制、修改、抄录、传播、发行或公开发表。否则，建华建材电子采购平台有权通过法律途径依法追究您的法律责任。
        div.my-2.body-2 六、 不可抗力
        div.mb-2 遭受不可抗力的一方可中止履行本协议项下的义务直至不可抗力事件的影响消除为止，并且无需承担违约责任，但应尽合理努力克服该事件、减少损失的扩大。不可抗力指该方不能控制、不可预见或即使预见亦无法避免的事件，该等不可抗力事件足以妨碍、影响或延误任何一方根据本协议履行其全部或部分义务。该事件包括但不限于自然灾害、战争、政策变化造成的事件。
        div.my-2.body-2 七、责任限制
        div.mb-2 1.您理解并同意，您在使用建华建材电子采购平台服务及相关网络服务过程中存在的风险将完全由您本人承担，建华建材电子采购平台在本协议约定的责任范围以外不承担任何责任。
        div.mb-2 2.在法律允许的情况下，建华建材电子采购平台对于与本协议有关的任何间接的、惩罚性的、特殊的、派生的损失（包括但不限于业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不承担任何责任，即使事先已被告知此等损失的可能性。
        div.mb-2 3.您理解并确认，对于建华建材电子采购平台向您提供的下列服务本身及其引发的任何损失，建华建材电子采购平台无需承担任何责任：
        div.mb-1 1） 建华建材电子采购平台向您免费提供的各项网络服务；
        div.mb-1 2） 建华建材电子采购平台向您赠送或附赠的任何产品或服务。
        div.mb-2 4.您理解并确认，建华建材电子采购平台可能因下列情况无法正常提供服务，建华建材电子采购平台就此不承担损害赔偿责任：
        div.mb-1 1） 建华建材电子采购平台在系统停机维护期间；
        div.mb-1 2） 电信设备出现故障不能进行数据传输；
        div.mb-1 3） 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。
        div.mb-2 5.您理解并同意，因您使用建华建材电子采购平台服务、违反本协议或在您的帐号下采取的任何行动，而导致的任何第三方索赔，应且仅应由您本人承担。如果由此引起建华建材电子采购平台及其关联公司、员工、客户、供应商和合作伙伴被第三方索赔的，您应承担全部责任。
        div.mb-2 6.您通过建华建材电子采购平台服务访问和使用的建华建材电子采购平台合作伙伴或入驻建华建材电子采购平台的第三方服务商的服务质量仅为该第三方的责任，对于该第三方的服务，建华建材电子采购平台在任何情况下都不会承担责任。
        div.my-2.body-2 八、适用法律与争议解决
        div.mb-2 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，均应依照提交江苏省镇江市中级人民法院予以审理。
</template>
<script>
export default {
  data () {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      h: "",
      formAuth: {
        pk_org: "",
        name: "",
        address: "",
        registered_funds: "",
        registrant: "",
        registrant_phone: "",
        scope: "",
        tax_class: "",
        img_tax_class: "",
        credit_code: "",
        img_business_license: "", //营业许可证
        img_bank_license: "", //开户行许可证
        img_registrant_id_card: "", //法人身份证正面
        img_registrant_id_card_back: "", //法人身份证反面
        img_agent_id_card: "", //代理人身份证正面
        img_agent_id_card_back: "", //代理人身份证反面
        // bank_name: "",
        // bank_code: "",
        // bank_account: "",
        contact: "",
        contact_phone: "",
        type: 1,
        supplier_level: null,
        id_num: "",
        supplierBank: [],
      },
      rules: {
        pk_org: [
          { required: true, message: "请选择管理组织", trigger: "change" },
        ],
        name: [
          {
            required: true,
            message: "请填写企业名称/个体名称",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请填写注册地址", trigger: "blur" },
        ],
        registered_funds: [
          { required: true, message: "请填写注册资金", trigger: "blur" },
        ],
        registrant: [
          { required: true, message: "请填写法人姓名", trigger: "blur" },
        ],
        registrant_phone: [
          { required: true, message: "请填写法人电话", trigger: "blur" },
        ],
        scope: [{ required: true, message: "请填写经营范围", trigger: "blur" }],
        tax_class: [
          { required: true, message: "请填写纳税等级", trigger: "blur" },
        ],
        img_tax_class: [
          { required: true, message: "请上传纳税等级证明", trigger: "blur" },
        ],
        name_account: [
          { required: true, message: "请填写账户名", trigger: "blur" },
        ],
        ower_account: [
          { required: true, message: "请填写账户持有人", trigger: "blur" },
        ],
        is_private: [
          { required: true, message: "请选择是否私人账户", trigger: "change" },
        ],
        credit_code: [
          {
            required: true,
            message: "请填写统一社会信用代码",
            trigger: "blur",
          },
        ],
        img_business_license: [
          { required: true, message: "请上传营业许可证", trigger: "blur" },
        ],
        img_bank_license: [
          { required: true, message: "请上传开户行许可证", trigger: "blur" },
        ],
        img_registrant_id_card: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                this.formAuth.img_registrant_id_card &&
                this.formAuth.img_registrant_id_card_back
              ) {
                callback();
              } else {
                callback("请上传法人身份证正反面");
              }
            },
            trigger: "blur",
          },
        ],
        img_agent_id_card: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                this.formAuth.img_agent_id_card &&
                this.formAuth.img_agent_id_card_back
              ) {
                callback();
              } else {
                callback("请上传注册人身份证正反面");
              }
            },
            trigger: "blur",
          },
        ],
        // bank_name: [
        //   { required: true, message: "请上传营业许可证", trigger: "blur" },
        // ],
        // bank_code: [
        //   { required: true, message: "请填写开户行行号", trigger: "blur" },
        // ],
        // bank_account: [
        //   { required: true, message: "请填写银行账号", trigger: "blur" },
        // ],
        checked: [
          {
            validator: (rule, value, callback) => {
              if (!this.checked) {
                callback("请先阅读并同意《建华建材注册协议》");
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        contact: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        contact_phone: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
        ],
        id_num: [{ required: true, message: "请填身份证号", trigger: "blur" }],
        bank_code: [
          { required: true, message: "请选择开户行", trigger: "change" },
        ],
        bank_account: [
          { required: true, message: "请填写银行账号", trigger: "blur" },
        ],
      },
      checked: false,
      imageUrl: "",
      path: this.$api.file.upload_pic,
      form1: {
        bank_code: "",
        bank_name: "",
        bank_account: "",
        name_account: "",
        ower_account: "",
        is_private: "",
      },
      bankList: [],
      bankData: [],
      img_url: this.$api.file.img_url,
      bankItem: {
        code: null,
        name: null,
      },
      loadingBank: false,
    };
  },
  methods: {
    del (index) {
      this.bankData.splice(index, 1);
      // this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(async () => {
      //     this.bankData.splice(index, 1);
      //   })
      //   .catch(() => {});
    },
    async getBankList (query) {
      if (!query) {
        return false;
      }
      this.loadingBank = true;
      let res = await this.$api.global.getBankList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingBank = false;
      if (res) {
        this.bankList = res.data;
      }
    },
    changeBank () {
      this.form1.bank_code = this.bankItem.code;
      this.form1.bank_name = this.bankItem.name;
    },
    addBank () {
      this.$refs["form1"].validate(async (valid) => {
        if (valid) {
          this.bankData.push(this.$utils.cloneDeep(this.form1));
          this.$refs["form1"].resetFields();
          this.bankItem = {};
          this.dialogFormVisible = false;
        } else {
          return false;
        }
      });
    },
    changeType () {
      this.$refs.formAuth.resetFields();
      this.formAuth.name = this.supplier.name;
    },
    submitForm (form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          if (this.bankData.length <= 0) {
            this.$notify({
              message: "银行账号为空，请至少增加一条！",
              type: "error",
            });
          } else {
            this.formAuth.supplierBank = this.bankData;
            if (this.formAuth.type == '2') {
              this.formAuth.credit_code = this.formAuth.id_num;
            }
            let res = await this.$api.supplier.auth(this.formAuth);
            if (res) {

              this.$notify({
                message: "您已提交认证，请等待审核",
                type: "success",
              });
              this.$store.dispatch("SET_TOKEN", this.$store.state.token);
              this.$router.push("/interested");
            }
          }
        } else {
          return false;
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    beforeUpload (file, type) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        this.$notify({
          message: "上传图片只能是jpg/png/jpeg格式!",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess (res, file, type) {
      if (res.code == 200) {
        switch (type) {
          case 1:
            this.formAuth.img_business_license = res.data;
            this.$refs["formAuth"].$children[10].onFieldBlur();
            break;
          case 2:
            this.formAuth.img_bank_license = res.data;
            this.$refs["formAuth"].$children[11].onFieldBlur();
            break;
          case 3:
            this.formAuth.img_registrant_id_card = res.data;
            this.$refs["formAuth"].$children[12].onFieldBlur();
            break;
          case 4:
            this.formAuth.img_registrant_id_card_back = res.data;
            this.$refs["formAuth"].$children[12].onFieldBlur();
            break;
          case 5:
            this.formAuth.img_agent_id_card = res.data;
            this.$refs["formAuth"].$children[13].onFieldBlur();
            break;
          case 6:
            this.formAuth.img_agent_id_card_back = res.data;
            this.$refs["formAuth"].$children[13].onFieldBlur();
            break;
          case 7:
            this.formAuth.img_tax_class = res.data;
            this.$refs["formAuth"].$children[8].onFieldBlur();
            break;
          default:
            break;
        }
      }
    },
    async getQXB () {
      if (!this.formAuth.name) {
        this.$notify({
          message: "请填写企业名称",
          type: "error",
        });
        return false;
      }
      let res = await this.$api.supplier.qxborg_info({
        name: this.formAuth.name,
      });
      if (res) {
        this.formAuth.address = res.data.address;
        this.formAuth.registered_funds = res.data.regist_capi;
        this.formAuth.registrant = res.data.oper_name;
        this.formAuth.registrant_phone = res.data.contact.telephone; //法人电话
        this.formAuth.scope = res.data.scope;
        this.formAuth.credit_code = res.data.credit_no;
      }
    },
    async getSupplierInfo (user_code) {
      let res = await this.$api.supplier.getSupplierInfo({
        user_code: user_code,
      });
      if (res) {
        this.formAuth = res.data;
        this.bankData = this.formAuth.supplierBank;
        // this.formAuth.type = 1;
      }
    },
  },
  mounted () {
    this.formAuth.name = this.supplier.name;
    this.h = document.body.clientHeight - 100 - 120 + "px";
  },
  created () {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    this.getSupplierInfo(this.user.phone);
  },
};
</script>
